import operate from './operate.vue'

export const twinColumn = function () {
  return [
    {
      title: '序号',
      type: 'index',
      width: 47
    },
    {
      title: '姓名',
      width: 130,
      [$field]: 'userName',
    },
    {
      title: '工号',
      width: 160,
      [$field]: 'userCode'
    },
    {
      title: '性别',
      width: 100,
      [$field]: 'gender'
    },
    {
      title: '政治面貌',
      width: 130,
      [$field]: 'political'
    },
    {
      title: '组织全路径',
      [$field]: 'organization'
    },
    {
      title: '建立联系日期',
      width: 120,
      [$field]: 'organization1'
    },
    {
      'title': '操作',
      'width': 120,
      [$field]: 'operate',
      'isOperate': true,
      'slotComponent': operate
    }
  ]
}
export const infoColumn = function () {
  return [
    {
      title: '年度',
      width: 130,
      [$field]: 'userName',
    },
    {
      title: '标题',
      [$field]: 'userCode'
    },
    {
      title: '发布组织',
      width: 100,
      [$field]: 'gender'
    },
    {
      title: '发布日期',
      width: 130,
      [$field]: 'political'
    },
    {
      title: '最后一次更新日期',
      [$field]: 'organization'
    },
    {
      title: '阅读情况',
      width: 120,
      [$field]: 'organization1'
    },
    {
      'title': '信息状态',
      'width': 120,
      [$field]: 'operate'
    }
  ]
}
